import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { URLPaths } from 'models/enums';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: theme.spacing(4),
        textAlign: 'center',
    },
    icon: {
        fontSize: '4rem',
        color: theme.palette.error.main,
        marginBottom: theme.spacing(2),
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },
    message: {
        marginBottom: theme.spacing(4),
        color: theme.palette.text.secondary,
        maxWidth: '500px',
    },
    button: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * Access denied page shown to users when they don't have permission to access a route.
 */
const AccessDenied = () => {
    const classes = useStyles();
    const history = useHistory();

    const handleRedirect = () => {
        history.push(URLPaths.HOME_PAGE);
    };

    return (
        <Box
            className={classes.container}
            role="alert"
            aria-labelledby="access-denied-title"
            aria-describedby="access-denied-message"
        >
            <ErrorOutlineIcon className={classes.icon} aria-hidden="true" />
            <Typography id="access-denied-title" variant="h4" className={classes.title} component="h1">
                Access Restricted
            </Typography>
            <Typography id="access-denied-message" variant="body1" className={classes.message}>
                You don't have permission to view this page.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={handleRedirect}
                className={classes.button}
                size="large"
                aria-label="Navigate to home page"
            >
                Go to Home
            </Button>
        </Box>
    );
};

export default AccessDenied;
